/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./task-center-item.vue?vue&type=template&id=a9237c6c&scoped=true&"
import script from "./task-center-item.vue?vue&type=script&lang=ts&"
export * from "./task-center-item.vue?vue&type=script&lang=ts&"
import style0 from "./task-center-item.vue?vue&type=style&index=0&id=a9237c6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9237c6c",
  null
  
)

export default component.exports